import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useGetByTenantAssetListOrderAlertQuery } from '@/api/rtk-api'
import { Rule, SearchField, TablePagination } from '@/components/core-v2'
import { TENANT } from '@/const'
import { plural } from '@/utilities/plural'

import classes from './assets-filter-list.module.scss'
import { AssetsList } from './assets-list'
import { DEFAULT_QUERY } from './orders-filter-context'

export const AssetsFilterList = () => {
  const form = useForm({ defaultValues: { assetFilterSearch: '' } })
  const [pagination, setPagination] = useState({
    pageSize: DEFAULT_QUERY.pageSize,
    pageNumber: DEFAULT_QUERY.pageNumber
  })

  const { data, isLoading } = useGetByTenantAssetListOrderAlertQuery({
    pageNumber: pagination.pageNumber,
    pageSize: pagination.pageSize,
    wildcardString: form.watch('assetFilterSearch'),
    tenant: TENANT
  })
  const onPage = p => setPagination(p)

  return (
    <div className={classes.root}>
      <FormProvider {...form}>
        <SearchField className={classes.assetSearch} id="assetFilterSearch" />
      </FormProvider>
      <strong className={classes.assetResults}>
        {data?.totalDocuments} {plural('result', data?.totalDocuments)}
      </strong>
      <Rule className="my-3" />
      <TablePagination
        pagination={{ ...pagination, totalRows: data?.totalDocuments ?? 0 }}
        onChange={onPage}
      />
      <Rule className="my-3" />
      <AssetsList data={data?.data} isLoading={isLoading} />
    </div>
  )
}
